module.exports = __webpack_public_path__ + "static/media/CCU_Arg-17.1b575091.png";